const BRANDS = [
  {
    name: "Uber",
    logo: "https://www.outskill.com/home/nbs1.png",
  },
  {
    name: "Aditya Birla Group",
    logo: "https://www.outskill.com/home/nbs2.png",
  },
  {
    name: "Tata Communications",
    logo: "https://www.outskill.com/home/nbs7.png",
  },
  {
    name: "ShipRocket",
    logo: "https://www.outskill.com/home/nbs4.png",
  },
  {
    name: "Domino's",
    logo: "https://www.outskill.com/home/nbs5.png",
  },
  {
    name: "Shell",
    logo: "https://www.outskill.com/home/nbs6.png",
  },
  {
    name: "Fresenius Medical Care",
    logo: "https://www.outskill.com/home/nbs3.png",
  },
];

export default function B2BBrandsSection() {
  return (
    <section className="flex flex-col gap-6 animate-[fade-in_0.4s_ease-out_both]">
      <h3 className="text-white font-semibold text-lg">
        Brands in Collaboration
      </h3>

      <div className="flex flex-wrap items-center justify-start gap-x-10 gap-y-6">
        {BRANDS.map((brand) => (
          <div
            key={brand.name}
            className="opacity-70 hover:opacity-100 transition-opacity"
            title={brand.name}
          >
            <img
              src={brand.logo}
              alt={brand.name}
              className="h-8 sm:h-10 w-auto object-contain"
              loading="lazy"
            />
          </div>
        ))}
      </div>

      <div className="h-px w-full bg-gradient-to-r from-white/10 via-white/5 to-transparent mt-2" />
    </section>
  );
}
